import axios from 'axios';
import * as endpoints from './endpoints';

export function getAvailableUsers(siteId, data) {
  return axios.get(`${endpoints.SITE_MANAGEMENT}/${siteId}/users`, endpoints.headers(data));
}

export function updateUserAccessToSite(siteId, userList) {
  return axios.post(`${endpoints.SITE_MANAGEMENT}/${siteId}/users`, userList, endpoints.headers());
}

export function getAvailableSitesForUser(userId, data) {
  return axios.get(`${endpoints.SITE_MANAGEMENT}/${userId}/sites`, endpoints.headers(data));
}

export function updateSiteAccessForUser(userId, data) {
  return axios.put(`${endpoints.SITE_MANAGEMENT}/${userId}/sites`, data, endpoints.headers());
}
